import { UseMutateFunction, useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { disableConsistencyCheckRanMonitoring } from '@api/consistencyCheck';

import { IId } from '@interfaces/common/common';

import { ESnackbarTypes, EUserRoles } from '@enums/common';

import { CONSISTENCY_RAN_DISABLE_MONITORING, CONSISTENCY_RAN_TABLE } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

interface IUseMutateConsistencyCheckRanDisableMonitoring {
	disableMonitoring: UseMutateFunction<any, any, IId, any>;
	isLoadingDisableMonitoring: boolean;
}

export const useMutateConsistencyCheckRanDisableMonitoring = (): IUseMutateConsistencyCheckRanDisableMonitoring => {
	const queryClient = useQueryClient();
	const dispatch = useAppDispatch();

	const {
		mutate,
		isLoading,
	} = useMutation<IId>({
		mutationKey: [CONSISTENCY_RAN_DISABLE_MONITORING],
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		mutationFn: disableConsistencyCheckRanMonitoring,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.disableMonitoringConsistencyCheckRanTemplate,
				type: ESnackbarTypes.success,
			}));

			return [queryClient.invalidateQueries([CONSISTENCY_RAN_TABLE])];
		},
	});

	return {
		disableMonitoring: mutate,
		isLoadingDisableMonitoring: isLoading,
	};
};
